import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import ReactPlayer from "react-player";

import "./ModalVideo.css";

function ModalVideo({ data, open, close }) {
  const [play, setPlay] = useState(true);
  const [link, setLink] = useState(null);

  useEffect(() => {
    if (!open) {
      setPlay(false);
      setLink(null);
    } else {
      setLink(data.link);
    }
  }, [open]);

  function handleClose() {
    setPlay(false);
    setLink(null);
    close();
  }

  return (
    <Modal className="modal-iframe" key={`modal-iframe`} onCancel={handleClose} open={open} footer={[]}>
      <ReactPlayer playing={play} controls volume={1} url={link} />
    </Modal>
  );
}

export default ModalVideo;
